import { Box, Button } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { MeterInput, NewMeter } from '@vy/types';
import { CRITERION_OPERATORS } from '@vy/types';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CriterionItem } from './CriterionsItem';

type CriterionsItemsProps = {
  conditionIndex: number;
  onLastCriterionDelete?: () => void;
};

export const CriterionsItems: React.FC<CriterionsItemsProps> = ({
  conditionIndex,
  onLastCriterionDelete,
}) => {
  const { control } = useFormContext<MeterInput, unknown, NewMeter>();

  const criterions = useFieldArray({
    control,
    name: `filter.conditions.${conditionIndex}.criterions`,
  });

  const handleAddCriterion = () => {
    criterions.append({
      field: '',
      operator: CRITERION_OPERATORS.Contains,
      value: '',
    });
  };

  const handleDeleteCriterion = (index: number) => {
    if (criterions.fields.length === 1) {
      onLastCriterionDelete?.();

      return;
    }

    criterions.remove(index);
  };

  return (
    <>
      {criterions.fields.map((criterion, index) => (
        <CriterionItem
          key={criterion.id}
          conditionIndex={conditionIndex}
          criterionIndex={index}
          onCriterionDelete={handleDeleteCriterion}
        />
      ))}
      <Box>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          sx={(theme) => ({
            columnGap: '8px',
            paddingX: '20px',
            backgroundColor: '#fff',
            border: `1px solid ${theme.palette.divider}`,
          })}
          onClick={handleAddCriterion}
        >
          <VyIcon
            icon="PlusMedium"
            style={{
              transform: 'scale(0.8)',
            }}
          />
          And
        </Button>
      </Box>
    </>
  );
};
